// React
import React from "react";

// ANTD Notification
import { notification as Notification } from "antd";

// Icons
import {
  CheckCircleFilled,
  // InfoCircleFilled,
  // WarningFilled,
} from "@ant-design/icons";

// Styles
import "./notifications.scss";

export const customNotification = (type, message, description) => {
  Notification[type]({
    message: message,
    description: (
      <div className="fs-medium fw-500 notification-text">{description}</div>
    ),
    icon: type === "success" && (
      <CheckCircleFilled className="success-notification-icon" />
    ),
    // use this icon if you have better fill color
    // icon:
    //   type === "success" ? (
    //     <CheckCircleFilled className="success-notification-icon" />
    //   ) : type === "info" ? (
    //     <InfoCircleFilled className="info-notification-icon" />
    //   ) : (
    //     <WarningFilled className="warning-notification-icon" />
    //   ),
    style: { borderRadius: "10px" },
    className: "edit-goal-success-notification",
  });
  // return Notification.destroy();
};
